var map = {
	"./10_yellow.mp3": "baab",
	"./11_green.mp3": "8163",
	"./12_purple.mp3": "236c",
	"./13_pink.mp3": "3015",
	"./14_orange.mp3": "2075",
	"./1_hello.mp3": "36b2",
	"./2_bye_bye.mp3": "6ba6",
	"./3_Tom.mp3": "6c5b",
	"./4_Lisa.mp3": "47c4",
	"./5_rabbit.mp3": "a8f06",
	"./6_bear.mp3": "55f2",
	"./7_mole.mp3": "929b",
	"./8_blue.mp3": "9107",
	"./9_red.mp3": "a838",
	"./M_Brilliant.mp3": "0b6e",
	"./M_Excellent.mp3": "b12c",
	"./M_Fantastic.mp3": "805a",
	"./M_Great.mp3": "6407",
	"./M_Perfect.mp3": "90d6",
	"./M_Think again.mp3": "25a9",
	"./M_Try again.mp3": "8b52",
	"./M_Very good.mp3": "9cfe",
	"./M_Well done.mp3": "d48a",
	"./M_Work harder.mp3": "9c2e",
	"./click.mp3": "5b30"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a803";